import React from "react";
import PageTemplate from "./PageTemplate.jsx";

function DashboardTemplate({
  children,
  className = "",
  title = null,
  showTitle = true,
}) {
  return (
    <PageTemplate
      className={className}
      title={title}
      showTitle={showTitle}
      containerClassName="space-y-8"
    >
      {children}
    </PageTemplate>
  );
}

export default DashboardTemplate;
